var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "80%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.dataInfo.Device_WorkOrderFinishDetails,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _vm.dataInfo.device_WorkOrder.WorkOrderType === "0"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "运行时长", prop: "RunTime" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "运行时长",
                                      disabled: _vm.disabled,
                                    },
                                    model: {
                                      value:
                                        _vm.dataInfo
                                          .Device_WorkOrderFinishDetails
                                          .RunTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInfo
                                            .Device_WorkOrderFinishDetails,
                                          "RunTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataInfo.Device_WorkOrderFinishDetails.RunTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataInfo.device_WorkOrder.WorkOrderType === "0"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "总时长",
                                    prop: "TotalDuration",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "总时长",
                                    },
                                    model: {
                                      value:
                                        _vm.dataInfo
                                          .Device_WorkOrderFinishDetails
                                          .TotalDuration,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInfo
                                            .Device_WorkOrderFinishDetails,
                                          "TotalDuration",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataInfo.Device_WorkOrderFinishDetails.TotalDuration",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataInfo.device_WorkOrder.WorkOrderType === "0"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "巡检状态",
                                    prop: "InspectionStatus",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: _vm.disabled,
                                      placeholder: "巡检状态",
                                    },
                                    model: {
                                      value:
                                        _vm.dataInfo
                                          .Device_WorkOrderFinishDetails
                                          .InspectionStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInfo
                                            .Device_WorkOrderFinishDetails,
                                          "InspectionStatus",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n                  dataInfo.Device_WorkOrderFinishDetails.InspectionStatus\n                ",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "完成日期", prop: "ActualDate" },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  disabled: _vm.disabled,
                                  placeholder: "请选择日期",
                                },
                                model: {
                                  value:
                                    _vm.dataInfo.Device_WorkOrderFinishDetails
                                      .ActualDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataInfo
                                        .Device_WorkOrderFinishDetails,
                                      "ActualDate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dataInfo.Device_WorkOrderFinishDetails.ActualDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "说明" } }, [
                            _c("div", {
                              staticStyle: {
                                width: "100%",
                                height: "180px",
                                overflow: "auto",
                                border: "1px solid #e2e2e2",
                                padding: "10px",
                                "background-color": "#f5f7fa",
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.dataInfo.Device_WorkOrderFinishDetails
                                    .InspectionRecords
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "图片" } },
                            [
                              _vm.dataInfo.device_WorkOrderImgs.length == 0
                                ? _c("div", {
                                    staticStyle: { height: "200px" },
                                  })
                                : _vm._e(),
                              _vm._l(
                                _vm.dataInfo.device_WorkOrderImgs,
                                function (v) {
                                  return _c("el-image", {
                                    key: v.url,
                                    staticClass: "image-item",
                                    attrs: {
                                      src: v.url,
                                      "preview-src-list": [v.url],
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "评价状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isLog,
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value:
                                      _vm.dataInfo.device_WorkOrder
                                        .EvaluationStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataInfo.device_WorkOrder,
                                        "EvaluationStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataInfo.device_WorkOrder.EvaluationStatus",
                                  },
                                },
                                [
                                  _c(
                                    "el-option",
                                    { attrs: { value: "不合格" } },
                                    [_vm._v(" 不合格 ")]
                                  ),
                                  _c(
                                    "el-option",
                                    { attrs: { value: "合格" } },
                                    [_vm._v(" 合格 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "评价结果" } },
                            [
                              _vm.isLog
                                ? _c("div", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "200px",
                                      overflow: "auto",
                                      border: "1px solid #e2e2e2",
                                      padding: "10px",
                                      "background-color": "#f5f7fa",
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.dataInfo.device_WorkOrder
                                          .CompleteDescription
                                      ),
                                    },
                                  })
                                : _c("quill-editor", {
                                    ref: "myQuillEditor",
                                    staticStyle: { height: "400px" },
                                    attrs: { options: _vm.editorOption },
                                    model: {
                                      value:
                                        _vm.dataInfo.device_WorkOrder
                                          .CompleteDescription,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInfo.device_WorkOrder,
                                          "CompleteDescription",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataInfo.device_WorkOrder.CompleteDescription",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "检查" } }, [
                            _c("div", {
                              staticStyle: {
                                width: "100%",
                                height: "200px",
                                overflow: "auto",
                                border: "1px solid #e2e2e2",
                                padding: "10px",
                                "background-color": "#f5f7fa",
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.dataInfo.device_WorkOrder
                                    .AIFaultDescription
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isLog
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.close } }, [
                    _vm._v("取消"),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.subData } },
                    [_vm._v("审查保存")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }